export const FETCH_CUSTOMERS_REQUESTED = 'FETCH_CUSTOMERS_REQUESTED'
export const FETCH_CUSTOMERS_SUCCEEDED = 'FETCH_CUSTOMERS_SUCCEEDED'
export const FETCH_CUSTOMERS_FAILED = 'FETCH_CUSTOMERS_FAILED'
export const SET_ACTIVE_CUSTOMER = 'SET_ACTIVE_CUSTOMER'

export const fetchCustomers = () => ({
  type: FETCH_CUSTOMERS_REQUESTED,
})

export const fetchCustomersSucceeded = (payload) => ({
  type: FETCH_CUSTOMERS_SUCCEEDED,
  payload,
})

export const fetchCustomersFailed = (payload) => ({
  type: FETCH_CUSTOMERS_FAILED,
  payload,
})

export const setActiveCustomer = (customerId) => ({
  type: SET_ACTIVE_CUSTOMER,
  payload: { customerId }
})
